/**
 * @generated SignedSource<<b507c39bbf808d86cebbe2a51e74cf00>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleLandingVideo_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly " $fragmentType": "SbSharedContentModuleLandingVideo_viewer";
};
export type SbSharedContentModuleLandingVideo_viewer$key = {
  readonly " $data"?: SbSharedContentModuleLandingVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleLandingVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleLandingVideo_viewer",
  "selections": [
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5ca0b9e3d9fef6753d328c5aa8d67167";

export default node;
